module.exports = __webpack_public_path__ + "media/mobile/icon-select--grey-93f8ea9e.svg";